import { render, staticRenderFns } from "./SuccessDetail.vue?vue&type=template&id=0230957e&"
import script from "./SuccessDetail.vue?vue&type=script&lang=ts&setup=true&"
export * from "./SuccessDetail.vue?vue&type=script&lang=ts&setup=true&"


/* normalize component */
import normalizer from "!../../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/prodoctorov/pd-ssr/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0230957e')) {
      api.createRecord('0230957e', component.options)
    } else {
      api.reload('0230957e', component.options)
    }
    module.hot.accept("./SuccessDetail.vue?vue&type=template&id=0230957e&", function () {
      api.rerender('0230957e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/pages/appointment/vrach/new/components/DoctorAppointmentForm/components/AppointmentScreens/components/SuccessDetail.vue"
export default component.exports